let autocomplete, mapita, realMarker;




function initMap() {
  const mapaContainer = document.getElementById("mapitaCool");
  const urlchida = document.getElementById("url_chida");

  autocomplete = new google.maps.places.Autocomplete(
    document.getElementById("autocomplete"),
    { types: ["geocode"] }
  );

  autocomplete.setFields(["address_component", "formatted_address", "place_id", "url", "geometry"]);

  mapita = new google.maps.Map(mapaContainer, {
    center: { lat: -17.749642, lng: -63.169050 },
    zoom: 15,
    gestureHandling: "greedy", // Permite mover el mapa con un dedo en móviles
    fullscreenControl: false // Desactiva el botón de pantalla completa
  });

  if (window.innerWidth <= 600) {
    mapaContainer.style.height = "450px";
  } else {
    mapaContainer.style.height = "400px";
  }

  // Colocamos el marcador falso centrado en la pantalla (SVG como pin visual, no parte del mapa)
  const fakeMarker = document.createElement('div');
  fakeMarker.innerHTML = `
    <svg height="80px" width="70px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <g id="_x31_57_x2C__Twitter_x2C__Location_x2C__Map">
        <g>
          <path d="M256.08,54.999c84.87,0,153.81,68.94,153.81,153.96c0,77.059-87.02,195.03-153.2,246.04    c-85.33-69.24-154.58-167.75-154.58-246.04C102.11,123.938,171.05,54.999,256.08,54.999z M330.87,205.798    c0-41.34-33.521-74.86-74.87-74.86c-41.35,0-74.86,33.52-74.86,74.86c0,41.35,33.51,74.87,74.86,74.87    C297.35,280.668,330.87,247.148,330.87,205.798z" style="fill:#FF7979;"/>
        </g>
      </g>
      <g id="Layer_1"/>
    </svg>
  `;
  fakeMarker.style.position = 'absolute';
  fakeMarker.style.top = '50%';
  fakeMarker.style.left = '50%';
  fakeMarker.style.transform = 'translate(-50%, -70%)'; // Mueve un poco hacia abajo
  fakeMarker.style.zIndex = '1';
  mapaContainer.appendChild(fakeMarker);

  // Evento que se activa cuando el usuario deja de mover el mapa
  google.maps.event.addListener(mapita, "dragend", function () {
    placeRealMarker();
  });

  function placeRealMarker() {
    const center = mapita.getCenter();
    const lat = center.lat();
    const lng = center.lng();

    if (realMarker) {
      realMarker.setMap(null); // Elimina el marcador anterior si ya existe
    }

    // Crear un marcador con un ícono transparente
    realMarker = new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: mapita,
      icon: {
        path: google.maps.SymbolPath.CIRCLE, // Usa un símbolo vacío
        scale: 0, // Define el tamaño a 0 para que sea invisible
      }
    });

    // Convierte las coordenadas y genera la URL
    const latitud = lat >= 0 ? convertirCoordenadas(lat) + 'N' : convertirCoordenadas(lat) + 'S';
    const longitud = lng >= 0 ? convertirCoordenadas(lng) + 'E' : convertirCoordenadas(lng) + 'W';

    urlchida.value = `https://www.google.com/maps/place/${latitud}, ${longitud}`;

    var event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    urlchida.dispatchEvent(event); // Simulación de cambio manual para URL Chida
  }

  function convertirCoordenadas(grados) {
    const absoluto = Math.abs(grados);
    const gradosEnteros = Math.floor(absoluto);
    const minutos = (absoluto - gradosEnteros) * 60;
    const minutosEnteros = Math.floor(minutos);
    const segundos = (minutos - minutosEnteros) * 60;
    return `${gradosEnteros}°${minutosEnteros}'${segundos.toFixed(1)}"`;
  }
}

function geolocate() {
  const defaultLocation = { lat: -17.749642, lng: -63.169050 };
  const geolocationOptions = { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 };

  function setAutocompleteBounds(geolocation) {
    const circle = new google.maps.Circle({
      center: geolocation,
      radius: geolocation.coords ? geolocation.coords.accuracy : 10,
    });
    autocomplete.setBounds(circle.getBounds());
  }

  navigator.geolocation.getCurrentPosition(
    position => setAutocompleteBounds(position),
    error => setAutocompleteBounds(defaultLocation),
    geolocationOptions
  );
}
